import CryptoJS from "crypto-js";
export const encryptData = ({ data, key }) => {
  if (key === localStorage.getItem("token")) {
    return CryptoJS.AES.encrypt(data, key).toString();
  } else {
    return "Invalid key";
  }
};

export const decryptData = ({ data, key }) => {
  if (key === localStorage.getItem("token")) {
    return CryptoJS.AES.decrypt(data, key).toString(CryptoJS.enc.Utf8);
  } else {
    return "Invalid key";
  }
};
